import { provideHttpClient } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { NgxMaskModule } from 'ngx-mask';
import { environment } from '../environments/environment';

import { getAnalytics, provideAnalytics } from '@angular/fire/analytics';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { getStorage, provideStorage } from '@angular/fire/storage';

import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';

// Servicios propios
import { AuthService } from './services/auth.service';
import { DialogService } from './services/dialog.service';
import { FirestoreService } from './services/firestore.service';
import { ThemeService } from './services/theme.service';
import { UserService } from './services/user.service';

// Rutas (standalone)
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { routes } from './app-routing.module';

export const appConfig = {
    providers: [
        provideHttpClient(),
        provideAnimations(),
        provideRouter(routes),

        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideAuth(() => getAuth()),
        provideFirestore(() => getFirestore()),
        provideStorage(() => getStorage()),
        provideAnalytics(() => getAnalytics()),
        provideFunctions(() => getFunctions()),

        importProvidersFrom(MatDialogModule, MatSnackBarModule, MatFormFieldModule, NgxMaskModule.forRoot()),

        ThemeService,
        DialogService,
        AuthService,
        FirestoreService,
        UserService,

        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                appearance: 'outline',
                subscriptSizing: 'dynamic',
            },
        },
    ],
};
